import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Button,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";
import EmailSignupModal from "./EmailSignupModal";
import jeremiah1 from "../images/georgiaNative.jpg";
import jeremiah2 from "../images/familyPortrait.jpg";
import howardGraduation from "../images/howardGraduation.jpg";
import targetImage from "../images/MeetJeremiahHeader.jpg";
import { useState } from "react";
const MeetJeremiah = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [emailOpen, setEmailOpen] = useState(false);
  return (
    <Box sx={{ backgroundColor: "#1d2845!important" }}>
      {/* Header Section */}
      <Box
        sx={{
          backgroundImage: `url(${targetImage})`,

          backgroundSize: "cover",
          backgroundPosition: isMobile ? "center" : "top",
          backgroundRepeat: "no-repeat",
          height: isMobile ? "30vh" : "50vh",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          textAlign: "center",
          p: isMobile ? 2 : 4,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: "white",
            fontWeight: "900!important",
            fontSize: {
              xs: "2.5rem",
              fontSize: isMobile ? "3rem!important" : "4rem!important",
              textTransform: "uppercase",
              fontWeight: "500!important",
            },
          }}
        >
          Meet Jeremiah
        </Typography>
      </Box>
      {/* Body Section */}
      <Box p={isMobile ? "0 16px" : "96px 96px 48px"}>
        <Grid container alignItems="flex-start">
          <Grid container className="section-wrap" mt={0} mb={isMobile ? 2 : 0}>
            <Grid item display="flex" flexDirection="column" xs={12} md={5} my={isMobile ? 2 : 0}>
              <img src={jeremiah1} alt="Jeremiah" style={{ width: "100%", borderRadius: 8, marginBottom: "1rem" }} />
            </Grid>
            <Grid item xs={false} md={1.25} sx={{ display: isMobile ? "none" : "initial" }}></Grid>
            <Grid item xs={12} md={5.5} sx={{ display: "flex", alignItems: "center" }}>
              <Box>
                <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "#fffdf7 !important", mb: 2 }}>
                  Jeremiah Pope has been a resident of Montgomery County, Maryland for nearly twenty years, moving here to work for Tom Perez for Maryland Attorney General.
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "#fffdf7 !important", mb: 2 }}>
                  In 2006, Jeremiah started a small business, J Pope Consulting, a professional fundraising and consulting company. He saw the absence of Blacks in the political space, and he wanted to change the deficiency of diversity in the industry. Through determination, hard work, and drive to affect change in his community, he persevered to grow his small minority-owned business into a premier fundraising business in the D.C. Metro Area. Eighteen years later, J Pope Consulting has been an integral part in diversifying the industry and winning Democratic races up and down the ballot.
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "#fffdf7 !important" }}>
                  Jeremiah was a pivotal part of the election of Donna F. Edwards, the first African American woman to Congress from the State of Maryland. Jeremiah also had leading roles in the elections of many other notable Congressional Black Caucus Members.
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid container className="section-wrap" my={isMobile ? 2 : 12}>
            <Grid item xs={false} md={0.25} my={4} sx={{ display: isMobile ? "none" : "initial", order: "1" }}></Grid>
            <Grid item xs={12} md={5.5} mt={isMobile ? 2 : 2} sx={{ order: isMobile ? "3" : "1", display: "flex", alignItems: "center" }}>
              <Box>
                <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "#fffdf7 !important", mb: 2 }}>
                  In 2019, Jeremiah accepted a public servant position as the Chief of Staff in the office of Maryland’s Deputy Majority Whip, Delegate Charlotte Crutchfield. He has worked with advocates, stakeholders, and members of the Maryland General Assembly to draft, pass, and implement legislation that breaks down systemic barriers, protects women and children, fights against hate crimes, and improves access to services for all Marylanders.
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "#fffdf7 !important" }}>
                  Since moving to Montgomery County, Jeremiah has actively worked to maintain and improve our community. He had the honor of serving as the president of the Hillandale Citizens Association, the only other Black president since 1998. In addition, he served on the boards of the East County Citizens Advisory Board, Friends of White Oak, the Community Services Agency of the Metropolitan Washington Council AFL-CIO, the Association of Black Democrats of Montgomery County, Iota Upsilon Lambda Chapter of Alpha Phi Alpha Fraternity, Inc., the National Pan-Hellenic Council of Montgomery County, the NAACP Parents’ Council, and Chair of the Maryland Democratic Party African American Diversity Leadership Council.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={5} display="flex" flexDirection="column" sx={{ order: isMobile ? "1" : "3", padding: isMobile ? "0" : "1rem", maxHeight: "fit-content" }}>
              <img src={howardGraduation} alt="Jeremiah" style={{ width: "100%", borderRadius: 8, marginBottom: "1rem" }} />
            </Grid>
          </Grid>

          <Grid container className="section-wrap" my={isMobile ? 2 : 0}>
            <Grid display="flex" flexDirection="column" item xs={12} md={5} my={isMobile ? 2 : 0}>
              <img src={jeremiah2} alt="Jeremiah family" style={{ width: "100%", borderRadius: 8, marginBottom: "1rem" }} />
            </Grid>
            <Grid item xs={false} md={1.25} sx={{ display: isMobile ? "none" : "initial" }}></Grid>
            <Grid item xs={12} md={5.5} sx={{ display: "flex", alignItems: "center" }}>
              <Box>
                <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "#fffdf7 !important", mb: 2 }}>
                  Jeremiah was born in Nashville, Tennessee, and grew up in Aiken, South Carolina. He was raised by his grandmother, a nurse, and his grandfather, a railroad worker. His grandparents instilled in him the value of education, faith, honesty, hard work, and civic duty. As a child, Jeremiah participated in the local NAACP meetings with his grandmother because she wanted to ensure that he understood what it means to advocate for one’s community.
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "#fffdf7 !important", mb: 2 }}>
                  After graduating from a public high school, Jeremiah was accepted to the College of Charleston in Charleston, South Carolina. While in college, Jeremiah was a recipient of a work study grant. He worked at the college library and met his future wife, Angie, who also worked at the library. Jeremiah became a member of Alpha Phi Alpha Fraternity, Inc. and worked at Wings for Kids, a program that served marginalized youth. His wife Angie is a member of Zeta Phi Beta Sorority, Inc.
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "#fffdf7 !important", mb: 2 }}>
                  In 2003, Jeremiah graduated from the College of Charleston with a Bachelor of Arts in Political Science. He then headed to Washington, D.C. to participate in a prestigious internship with United States Senator Ernest "Fritz" Hollings as well as with the EMILY’s List Campaign Corps program.
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "#fffdf7 !important", mb: 2 }}>
                  After his internships, Jeremiah began his professional career working around the country campaigning for Democrats to local, state, and federal offices. During this time, Jeremiah earned a Master of Arts in Public Policy degree from New England College.
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "#fffdf7 !important" }}>
                  Jeremiah and his wife attend Kingdom Fellowship AME Church in Calverton, Maryland with their son who is an elementary student in Montgomery County Public Schools. They are proud active members of their son’s elementary school’s Parent Teacher Association (PTA) of which Angie served as President. Jeremiah and his family live in the Silver Spring area of Montgomery County, Maryland.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* Footer */}
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          mb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", background: "#00853e!important" }}
              onClick={() => setEmailOpen(true)}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton component="a" href="https://instagram.com/popeforcouncil" target="_blank" rel="noopener noreferrer">
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton component="a" href="https://twitter.com/popeforcouncil" target="_blank" rel="noopener noreferrer">
              <TwitterIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton component="a" href="https://facebook.com/popeforcouncil" target="_blank" rel="noopener noreferrer">
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton component="a" href="https://www.youtube.com/@JeremiahPopeForCouncil" target="_blank" rel="noopener noreferrer">
              <YouTubeIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton component="a" href="mailto:info@popeforcouncil">
              <EmailIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid item sx={{ px: 1 }}>
            <Typography
              variant="h6"
              sx={{
                border: "1px solid white",
                padding: ".1rem .5rem !important",
                borderRadius: ".25rem!important",
                color: "white",
                fontSize: "1rem!important",
                margin: "1rem",
              }}
            >
              By Authority: Pope For Council, Angie Logan-Pope, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};
export default MeetJeremiah;
